export enum Region {
	US = 'us',
	EU = 'eu',
	AP = 'ap',
}

export const HubRegionToRegion = {
	US: Region.US,
	EU: Region.EU,
	EMEA: Region.EU,
	APAC: Region.AP,
	AP: Region.AP,
	AUS: Region.AP,
};

export enum SupportedRegionCountryCode {
	USA = 'usa',
	GBR = 'gbr',
	AUS = 'aus',
	IRL = 'irl',
}
